import { Injectable } from '@angular/core';
import { LoggingService } from '../../logging/logic/logging.service';
import { ActionHandler, ActionHandlerType } from '../action-handler';
import { ClientStateService } from '../../client-state/logic/client-state.service';
import { ServicejobsService } from '../../servicejobs/logic/servicejobs.service';
import { IMSId, IMSObject } from 'src/app/_model/ims-object';
import { EmpJobMappingsService } from '../../emp-job-mapping/logic/emp-job-mapping.service';

@Injectable({
  providedIn: 'root',
})
export class FinishedServicejobActionHandler implements ActionHandler {
  // Public Member
  public readonly name: ActionHandlerType = 'fns_jobs';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private clientStateService: ClientStateService,
    private servicejobsService: ServicejobsService,
    private empJobMappingService: EmpJobMappingsService,
  ) {}

  // ActionHandler
  public async executeAction(params?: any): Promise<any> {
    this.logger.log(
      this.constructor.name,
      'Received Action',
      this.name,
      'with params',
      params,
    );

    const imsId = params?.objid;

    const objId: IMSId = {
      imsId: +imsId,
      secondaryId: undefined,
      objRef: 'ims/ServiceJob',
    };

    const clientState = this.clientStateService.theState.getValue();
    if (
      IMSObject.equals(objId, clientState?.serviceJobId) ||
      IMSObject.equals(objId, clientState?.targetServiceJobId)
    ) {
      this.logger.warn(
        this.constructor.name,
        'cannot remove closed servicejob, as it is the current sjob of the app',
      );
      return;
    }

    const sjob = this.servicejobsService.getServiceJobById(objId);
    if (sjob == undefined) {
      this.logger.warn(
        this.constructor.name,
        'cannot remove closed servicejob, as it is not available in the app',
        JSON.stringify(objId),
        sjob,
      );
      return;
    }
    await this.empJobMappingService.removeEmpJobMapping(sjob);
    await this.servicejobsService.removeServicejob(sjob);
    this.logger.log(
      this.constructor.name,
      'Successfully removed sjob',
      sjob?.getImsId(),
      sjob?.label,
    );
  }

  // Private Functions
}
